import React, { useEffect } from 'react';
import { Calendar, Clock, CheckCircle } from 'lucide-react';
import { useLanguage } from '../context/LanguageContext';
import { Card, CardContent } from '../components/ui/card';
import { Badge } from '../components/ui/badge';

const Demo = () => {
  const { language } = useLanguage();

  useEffect(() => {
    // Load Calendly widget script
    const script = document.createElement('script');
    script.src = 'https://assets.calendly.com/assets/external/widget.js';
    script.async = true;
    document.body.appendChild(script);

    return () => {
      document.body.removeChild(script);
    };
  }, []);

  const benefits = [
    language === 'es' ? 'Consultoría personalizada' : 'Personalized consultation',
    language === 'es' ? 'Demo en vivo de la plataforma' : 'Live platform demo',
    language === 'es' ? 'Análisis de tu caso de uso' : 'Analysis of your use case',
    language === 'es' ? 'Plan de implementación' : 'Implementation plan'
  ];

  return (
    <div className="bg-black text-white min-h-screen">
      {/* Hero Section */}
      <section className="py-20 bg-gradient-to-br from-green-900/20 via-black to-emerald-900/20">
        <div className="container mx-auto px-4">
          <div className="max-w-4xl mx-auto text-center mb-12">
            <Badge className="bg-green-600/20 text-green-400 border-green-600/30 mb-6 px-4 py-2">
              {language === 'es' ? 'Agenda una Demo' : 'Schedule a Demo'}
            </Badge>
            <h1 className="text-4xl md:text-6xl font-bold mb-6">
              {language === 'es' ? 'Descubre el poder de' : 'Discover the power of'}{' '}
              <span className="text-transparent bg-clip-text bg-gradient-to-r from-green-400 to-emerald-400">
                GERVIS
              </span>
            </h1>
            <p className="text-xl text-gray-200 mb-8">
              {language === 'es'
                ? 'Agenda una llamada de 30 minutos con nuestro equipo para ver cómo GERVIS puede transformar tu negocio'
                : 'Schedule a 30-minute call with our team to see how GERVIS can transform your business'}
            </p>
          </div>

          {/* Benefits Grid */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6 max-w-3xl mx-auto mb-12">
            {benefits.map((benefit, index) => (
              <Card key={index} className="bg-gradient-to-br from-gray-900 to-black border-green-900/30">
                <CardContent className="p-6 flex items-center space-x-4">
                  <div className="w-12 h-12 bg-green-600/20 rounded-full flex items-center justify-center flex-shrink-0">
                    <CheckCircle className="w-6 h-6 text-green-400" />
                  </div>
                  <span className="text-lg text-gray-200">{benefit}</span>
                </CardContent>
              </Card>
            ))}
          </div>
        </div>
      </section>

      {/* Calendar Section */}
      <section className="py-12 bg-gradient-to-b from-black to-gray-900">
        <div className="container mx-auto px-4">
          <div className="max-w-4xl mx-auto">
            <Card className="bg-gradient-to-br from-gray-900 to-black border-green-600/30">
              <CardContent className="p-8">
                <div className="text-center mb-8">
                  <div className="w-16 h-16 bg-green-600/20 rounded-2xl flex items-center justify-center mx-auto mb-4">
                    <Calendar className="w-8 h-8 text-green-400" />
                  </div>
                  <h2 className="text-2xl font-bold mb-2 text-white">
                    {language === 'es' ? 'Selecciona tu horario' : 'Select your time'}
                  </h2>
                  <p className="text-gray-200">
                    {language === 'es'
                      ? 'Elige el día y hora que mejor te convenga'
                      : 'Choose the day and time that works best for you'}
                  </p>
                </div>

                {/* Calendly Embed Container */}
                <div 
                  className="calendly-inline-widget" 
                  data-url="https://calendly.com/gervis-ia/30min"
                  style={{ minHeight: '1500px', width: '100%' }}
                ></div>
              </CardContent>
            </Card>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Demo;